import { ITuileNav } from '@/models/ui/ITuileNav'
export const DashboardAdmin = {
  text: 'Administration',
  disabled: false,  
  to: {name:'ProfilAccount'},        
  exact:true
}

export const EnVisio:ITuileNav = {
  id:11,
  title:"Cours de natation en Visio",
  subtitle:"Plus simple plus rapide",      
  image:require('@/assets/photos/tuile/visio.jpg'),
  to:{name:'Visio'}
}

export const ADomicile:ITuileNav = {
  id:1000,
  title:"Cours de natation à domicile",
  subtitle:"Plus rassurant pour votre enfant",      
  image:require('@/assets/photos/tuile/domicile2.jpg'),
  to:{name:'Domicile'}
}

export const ADomicileAdulte:ITuileNav = {
  id:2000,
  title:"Cours de natation et d'aquafitness à domicile",
  subtitle:"Plus rassurant plus rapide",      
  image:require('@/assets/photos/tuile/domicile3.jpg'),
  to:{name:'Domicile'}
}


export const ADomicileNatationAdulte:ITuileNav = {
  id:14,
  title:"Cours de natation à domicile",
  subtitle:"Plus rassurant plus rapide",      
  image:require('@/assets/photos/tuile/domicile.jpg'),
  to:{name:'Domicile'}
}

export const ADomicileAquafitnsessAdulte:ITuileNav = {
  id:15,
  title:"Cours d'aquafitness à domicile",
  subtitle:"Plus confortable plus rapide",      
  image:require('@/assets/photos/tuile/domicile3.jpg'),
  to:{name:'Domicile'}
}
